module.exports = __webpack_public_path__ + "static/media/delete.3e1f8ac9.svg";